
  import { defineComponent, onUnmounted, toRef, watch } from 'vue';
  import { Container } from '@/ui/components/Container';
  import { Box } from '@/ui/components/Box';
  import { ForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
  import { Loader } from '@/ui/components/Loader';
  import { PageTitle } from '@/ui/components/PageTitle';
  import ScheduleForm from '@/ui/components/schedule/ScheduleForm.vue';
  import { useSchedule } from '@/ui/concerns/schedule/useSchedule';

  export default defineComponent({
    name: 'ScheduleEditPage',
    components: {
      ScheduleForm,
      PageTitle,
      Container,
      Box,
      Loader,
      ForbiddenPage,
    },
    props: ['id'],
    setup(props) {
      const id = toRef(props, 'id');
      const {
        canAccessPage,
        store,
        entityItemOptions,
        checklistOptions,
        assigneeOptions,
        getRecord,
        updateRecord,
        updateUserOptions,
      } = useSchedule(id.value);

      watch(id, getRecord.run);

      onUnmounted(() => store.$reset());

      return {
        canAccessPage,
        getRecord,
        updateRecord,
        entityOptions: entityItemOptions,
        checklistOptions,
        userOptions: assigneeOptions,
        updateUserOptions,
      };
    },
  });
